module.exports = __webpack_public_path__ + "img/portugal.a3a29830.png";